<template>
    <div>
        <Loading  :active="isLoading" :can-cancel="true" :is-full-page="fullPage" />

        <Titulo titulo="CONSULTA DE PAGOS"/>

        <b-container class="mt-4 mb-5">
            <b-row class="mb-1">
                <!-- el formulario de busqueda (para administrador) -->
                <b-col cols="12" xs="4" sm="4" md="4" v-show="tipoUsuario == 'A'">
                    <b-form id="formConsPago" @submit.prevent="consultarPagoForm">
                        <b-input-group-append>
                            <b-form-input
                                name="num_contrato"
                                type="text"
                                placeholder="Contrato"
                                class="text-uppercase"
                                required
                            ></b-form-input>
                            <b-button type="submit" variant="primary">Buscar</b-button>
                        </b-input-group-append>
                    </b-form>
                </b-col>

                <!-- el selector de contratos -->
                <b-col cols="12" xs="4" sm="4" md="4" v-show="contratos.length > 1">
                    <b-button-group>
                        <b-button variant="primary">Seleccione el </b-button>
                        <b-dropdown variant="primary" right text="Contrato">
                            <b-dropdown-item v-for="cont in contratos" :key="cont.num_contrato" @click="consultarPago(cont.num_contrato)">{{ cont.num_contrato }}</b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                </b-col>

                <b-col cols="2"></b-col>

                <!-- espaciador -->
                <b-col cols="12" xs="2" sm="2" md="2"></b-col>

                <!-- fecha de actualizacion -->
                <b-col cols="12" xs="4" sm="5" md="4">
                    Fecha de actualización: {{ parametros.fecha_sincroniza }}
                </b-col>
            </b-row>

            <b-card class="mb-1">
                <b-row>
                    <b-col cols="12" md="6">
                        <b-row>
                            <b-col cols="12" md="3"><strong>Propietario:</strong></b-col>
                            <b-col cols="12" md="9">{{ contrato.PROPIETARIO }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="3"><strong>Domicilio:</strong></b-col>
                            <b-col cols="12" md="9">{{ contrato.DOMICILIO }}</b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-row>
                            <b-col cols="12" md="3"><strong>Contrato:</strong></b-col>
                            <b-col cols="12" md="9">{{ contrato.NUM_CONTRATO }}</b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <b-row class="mb-2">
                <b-col cols="12" md="5">
                    <!-- los pagos -->
                    <b-card class="gridDatos" 
                        header="Pagos"
                        border-variant="primary"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        
                    >
                        <b-table
                            hover
                            sticky-header="310px"
                            small=True
                            :items="pagos" :fields="fields_pagos"
                            select-mode="single"
                            selectable
                            @row-selected="consultaDetalles"
                        >

                            <template #cell(fecha)="data">
                                {{ data.value | fechaMx }} 
                            </template>

                            <template #cell(TOTAL_PAGO)="data">
                                {{ data.value | moneda }} 
                            </template>

                        </b-table>
                    </b-card>
                </b-col>
                <b-col cols="12" md="7">
                    <!-- los detalles de pagos -->
                    <b-card class="gridDatos" 
                        header="Detalle del pago"
                        border-variant="primary"
                        header-bg-variant="transparent"
                        header-border-variant="secondary"
                    >
                        <b-table 
                            striped hover 
                            sticky-header="280px"
                            small=True
                            :items="detalle_pagos" 
                            :fields="fields_detpagos"
                        >

                            <template #cell(periodo)="data">
                                <span class="small">{{ data.item.axo }} {{ data.item.bim }}</span>
                            </template>

                            <template #cell(descripcion)="data">
                                <span class="small">{{ data.item.descripcion }} {{ data.item.tipo_cuota }}</span>
                            </template>

                            <template #cell(subtotal)="data">
                                <span class="small">{{ (Number(data.item.importe) + Number(data.item.descuento)) | numero }}</span>
                            </template>

                            <template #cell(descuento)="data">
                                <span class="small">{{ data.item.descuento | numero }}</span>
                            </template>

                            <template #cell(importe)="data">
                                <span class="small">{{ data.item.importe | moneda }}</span>
                            </template>
                        </b-table>

                        <template #footer>
                            <b-row class="d-flex justify-content-end">
                                <b-col cols="12" md="2" class="text-right"><strong>Total </strong></b-col>
                                <b-col cols="12" md="3" class="text-right"><span>{{ totalDetalles | moneda }}</span></b-col>
                            </b-row>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
import Swal from 'sweetalert2'
const axios = require('axios');
import {mapState} from 'vuex'
var numeral = require("numeral");
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'ConsultaPagos',
    filters: {
        fechaMx: function(fecha) {
            if (fecha != "" && fecha != null) {
                let partesTodo = fecha.split(' ');
                let partesFecha = partesTodo[0].split('-');
                let dia = partesFecha[2];
                let mes = partesFecha[1];
                let anio = partesFecha[0];

                return dia+"/"+mes+"/"+anio;
            } else {
                return '';
            }
        },
        numero: function (value) {
            return numeral(value).format("0,0.00");
        },
        moneda: function (value) {
            return numeral(value).format("$0,0.00");
        }
    },
    components: {
        Titulo, Loading
    },
    data() {
        return {
            //
            contratos: [],
            contrato: {},
            parametros: {},
            pagos: [],
            detalle_pagos: [],
            fields_pagos: [
                { key: 'FOLIO', label: 'Folio' }, 
                { key: 'FECHA', label: 'Fecha' },
                { key: 'TOTAL_PAGO', label: 'Importe' }
                ],
            fields_detpagos: [
                'periodo',
                { key: 'descripcion', label: 'Descripción' },
                { key: 'subtotal', label: 'Importe' },
                'descuento',
                { key: 'importe', label: 'Pagado' },
                ],
            selected: [],
            // loader
            isLoading: true,
            fullPage: true
        }
    },
    created() {
        if (this.tipoUsuario == 'C') {
            this.traerContratos()
        }

        this.traerParametros()
    },
    mounted() {
        this.isLoading = false
    },
    methods: {
        traerParametros() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "parametros");
            formData.append("limite", 1);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.parametros = res.data
            });
        },
        traerContratos() {
            /* ===========================
            * se trae los contratos que ligan con el usuario logueado
            * se usa con los usuarios tipo colono para mostrar en automatico
            * su saldo en caso de ser un solo contrato
            * ========================= */
            var formData = new FormData();
            formData.append("accion", "traerContratos")
            formData.append("idUsuario", this.idUsuario)

            axios.post(`${this.url}/ajax/ajax.usuarios.php`, formData)
            .then(res => {
                if (res.data) {
                    this.contratos = res.data

                    if (this.contratos.length == 0) {
                        Swal.fire({
                            title: 'Atención',
                            text: 'No se encontrarón contratos ligados a su usuario, por favor comuniquese con la asociación de colonos',
                            icon: 'error',
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: '#3085d6',
                        })
                    }

                    if (this.contratos.length == 1) {
                        this.consultarPago(this.contratos[0].num_contrato)
                    }
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: 'No se encontrarón contratos ligados al usuario...',
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#3085d6',
                    })
                }
            });
        },
        procesaPago(formData) {
            this.contrato = {}
            this.pagos = []
            this.detalle_pagos = []
            this.otros_cargos = []

            this.isLoading = true
            axios.post(`${this.url}/ajax/ajax.contratos.php`, formData)
            .then(res => {
                this.isLoading = false

                this.contrato = res.data
                this.pagos = res.data.pagos

                if (Object.keys(this.contrato).length === 0) {
                    Swal.fire({
                        title: 'Atención',
                        text: 'Contrato no localizado',
                        icon: 'warning',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#3085d6',
                    })
                } else if (this.pagos.length === 0) {
                    this.$toasted.error("No se encontraron pagos!", { duration : 2000 });
                }
            });
        },
        consultarPagoForm() {
            const form = document.getElementById('formConsPago')
            var formData = new FormData(form);
            formData.append("accion", "conspagos");
            
            this.procesaPago(formData)
        },
        consultarPago(numContrato=0) {
            var formData = new FormData();
            formData.append("num_contrato", numContrato)
            formData.append("accion", "conspagos");
            
            this.procesaPago(formData)
        },
        consultaDetalles(item) {
            this.detalle_pagos = []

            if (item.length > 0) {
                var idPago = item[0]['ID_PAGO']
                this.detalle_pagos = []
    
                var formData = new FormData();
                formData.append("accion", "consDetallePago");
                formData.append("idPago", idPago);
                
                this.isLoading = true
                axios.post(`${this.url}/ajax/ajax.pagos.php`, formData)
                .then((res) => {
                    this.isLoading = false

                    this.detalle_pagos = res.data
    
                    if (Object.keys(this.detalle_pagos).length === 0 &&
                        Object.keys(this.otros_cargos).length === 0) {
                        this.$toasted.error("No se encontraron detalles del pago", { duration : 2000 });
                    }
                });
            }
        },
        imprimir() {
            window.open(`${this.url}/repDetPago.php?id=${this.contrato.ID_CONTRATO}`,'window')
        }
    },
    computed: {
        totalDetalles() {
            var total = 0

            this.detalle_pagos.forEach(element => {
                total += Number(element.importe)
            });

            return total
        },
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd', 'urlSandbox', 'token', 'idUsuario', 'tipoUsuario'])
    }
}
</script>

<style scoped>
.gridDatos {
    height: 400px;
}

</style>